import { NgModule } from '@angular/core';
import { LibraryAComponent } from './library-a.component';

@NgModule({
  declarations: [LibraryAComponent],
  imports: [
  ],
  exports: [LibraryAComponent]
})
export class LibraryAModule { }
